// DOCUMENTATION: https://kazupon.github.io/vue-i18n/guide/lazy-loading.html

import { nextTick } from "vue";
import { createI18n } from "vue-i18n";

import enLocale from "@/assets/locales/en.json";

import configureYupI18n from "./yup";

export const SUPPORT_LOCALES = ["en", "he"];

export function setupI18n(options = { locale: "en" }) {
  const i18n = createI18n(options);

  loadLocaleMessages(i18n.global, options.locale);

  setI18nLanguage(i18n.global, options.locale);
  return i18n;
}

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === "legacy") {
    i18n.locale = locale;
  } else {
    i18n.locale.value = locale;
  }

  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  document.querySelector("html").setAttribute("lang", locale);
}

export async function loadLocaleMessages(i18n, locale) {
  i18n.setLocaleMessage(locale, enLocale);
  return nextTick();
}

export const i18n = setupI18n({
  legacy: false,
  locale: import.meta.env.VITE_I18N_LOCALE || "he",
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || "he",
  globalInjection: true,
});

// Configure Yup with i18n
configureYupI18n(i18n.global);

export default i18n;
